/**
 * x_tarificador-cart-rates-storage.js
 * Manejo de LocalStorage para selección de región/comuna
 */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Guarda la selección actual de región y comuna en localStorage
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection = () => {
    // Priorizar los selectores del popup si están visibles
    let provinceSelect = document.getElementById('popupProvinceSelect');
    let citySelect = document.getElementById('popupCitySelect');
    
    // Si el popup no está visible o no existe, usar los del carrito
    const popup = document.getElementById('shippingPopup');
    if (!popup || popup.style.display === 'none') {
      provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      citySelect = document.getElementById('pscCartDropdownCitySelect');
    }
    
    // Si ninguno de los dos existe, intentar con el que esté disponible
    if (!provinceSelect) {
      provinceSelect = document.getElementById('pscCartDropdownProvinceSelect') || document.getElementById('popupProvinceSelect');
    }
    if (!citySelect) {
      citySelect = document.getElementById('pscCartDropdownCitySelect') || document.getElementById('popupCitySelect');
    }
    
    const selection = {
      province: provinceSelect?.value || null,
      city: citySelect?.options?.[citySelect.selectedIndex]?.text || null,
      timestamp: Date.now()
    };
    
    try {
      localStorage.setItem('haciendola_shipping_selection', JSON.stringify(selection));
    } catch(e) {
      console.warn('LocalStorage not available:', e);
    }
  };

  /**
   * Carga la selección guardada desde localStorage
   * @returns {Object} { province, city } o valores null si no existe/expiró
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection = () => {
    try {
      const saved = localStorage.getItem('haciendola_shipping_selection');
      if (saved) {
        const selection = JSON.parse(saved);
        // Validar que no sea muy antigua (más de 1 hora)
        if (Date.now() - selection.timestamp < 3600000) {
          return selection;
        }
      }
    } catch(e) {
      console.warn('Error loading from LocalStorage:', e);
    }
    return { province: null, city: null };
  };
})();